import {
   createStore,
   combineReducers,
   applyMiddleware,
   compose
} from 'redux';

import {
   createEpicMiddleware,
   combineEpics
} from 'redux-observable';

import
usersReducer
   from 'orden_express/users/usersReducer';

import
productsReducer
   from 'orden_express/products/productsReducer';

import
routesReducer
   from 'orden_express/routes/routesReducer';

import
ordersReducer
   from 'orden_express/orders/ordersReducer';

import
reportsReducer
   from 'orden_express/reports/reportsReducer';

import
loginReducer
   from 'orden_express/login/loginReducer';

import {
   fromServerGetUsers,
   fromServerSaveUser,
   fromServerSaveDeliveryPoint,
   fromServerGetCities,
} from 'orden_express/users/usersEpic';

import {
   fromServerSaveProduct,
   fromServerGetProductCategory,
   fromServerGetMeasureUnit,
   fromServerGetAllProducts,
   fromServerGetProductsFilter,

} from 'orden_express/products/productsEpic';

import {
   fromServerSaveOrderBegining,
   fromServerGetDeliveryDates,
   fromServerGetOrdersRequested,
   fromServerSaveOrderState,
   fromServerResponseGetOrderRequestedDetail,
   fromServerSaveOrderProduuctDetail,
   fromServerSendEmailOrder,
   fromServerDeleteOrder,
} from 'orden_express/orders/ordersEpic';

import {
   fromServerSaveRoute,
   fromServerGetRoutes,
} from 'orden_express/routes/routesEpic'

import {
   fromServerGetReportProductsRequested,
   fromServerGetReportDashboard,
   fromServerGetReportHistoryClient,
} from 'orden_express/reports/reportsEpic';

import {
   fromServerVerifiedUser
} from 'orden_express/login/loginEpic';

const epicMiddleware = createEpicMiddleware();

const rootReducer = combineReducers({
   userReducerState: usersReducer,
   productsReducerState: productsReducer,
   ordersReducerState: ordersReducer,
   routesReducerState: routesReducer,
   reportsReducerState: reportsReducer,
   loginReducerState: loginReducer,
});

const rootEpic = combineEpics(
   fromServerGetUsers,
   fromServerSaveUser,
   fromServerSaveDeliveryPoint,
   fromServerGetCities,
   fromServerSaveProduct,
   fromServerGetProductCategory,
   fromServerGetMeasureUnit,
   fromServerGetAllProducts,
   fromServerGetProductsFilter,
   fromServerSaveOrderBegining,
   fromServerGetDeliveryDates,
   fromServerGetOrdersRequested,
   fromServerSaveOrderState,
   fromServerSendEmailOrder,
   fromServerDeleteOrder,
   fromServerSaveRoute,
   fromServerGetRoutes,
   fromServerResponseGetOrderRequestedDetail,
   fromServerSaveOrderProduuctDetail,
   fromServerGetReportProductsRequested,
   fromServerGetReportDashboard,
   fromServerVerifiedUser,
   fromServerGetReportHistoryClient,
);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(
   rootReducer,
   composeEnhancers(
      applyMiddleware(epicMiddleware)
   )
);

epicMiddleware.run(rootEpic);

export default store;